import { render, staticRenderFns } from "./ReleaseManager.vue?vue&type=template&id=81ba8142&scoped=true&"
import script from "./ReleaseManager.vue?vue&type=script&lang=js&"
export * from "./ReleaseManager.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseManager.vue?vue&type=style&index=0&id=81ba8142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ba8142",
  null
  
)

export default component.exports